var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisacard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 16,
    viewBox: "0 0 25 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_831_67578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.25 0.25H2.75C1.64543 0.25 0.75 1.14543 0.75 2.25V13.75C0.75 14.8546 1.64543 15.75 2.75 15.75H22.25C23.3546 15.75 24.25 14.8546 24.25 13.75V2.25C24.25 1.14543 23.3546 0.25 22.25 0.25Z",
    fill: "white",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.28773 5.91444C2.76459 5.62751 2.16754 5.39674 1.5 5.23659L1.528 5.11188H4.26498C4.63596 5.12489 4.93699 5.23651 5.03495 5.63071L5.62977 8.46659L5.81198 9.32073L7.47797 5.11188H9.27679L6.60288 11.2775H4.80397L3.28773 5.91444ZM10.6 11.2841H8.89883L9.96285 5.11188H11.6639L10.6 11.2841ZM16.7668 5.26277L16.5354 6.59559L16.3816 6.53004C16.0737 6.40525 15.6674 6.28054 15.1144 6.29371C14.4427 6.29371 14.1415 6.56277 14.1345 6.82546C14.1345 7.11441 14.4989 7.30484 15.0939 7.58725C16.074 8.02719 16.5286 8.56557 16.5218 9.26819C16.5081 10.5486 15.346 11.3761 13.5611 11.3761C12.7979 11.3694 12.0628 11.2181 11.6638 11.0476L11.9019 9.66205L12.1259 9.76066C12.6789 9.99071 13.0428 10.089 13.722 10.089C14.2118 10.089 14.7369 9.89838 14.7436 9.48488C14.7436 9.21565 14.5199 9.01851 13.8617 8.71646C13.2178 8.42087 12.3568 7.92848 12.3708 7.04198C12.3781 5.84042 13.5611 5 15.241 5C15.899 5 16.4312 5.13789 16.7668 5.26277ZM19.0278 9.09749H20.4417C20.3718 8.78889 20.0496 7.31147 20.0496 7.31147L19.9307 6.77964C19.8467 7.00943 19.6999 7.38373 19.7069 7.37056C19.7069 7.37056 19.1678 8.7429 19.0278 9.09749ZM21.1276 5.11188L22.5 11.284H20.9249C20.9249 11.284 20.7708 10.5748 20.7219 10.3581H18.5378C18.4746 10.5222 18.1808 11.284 18.1808 11.284H16.3958L18.9226 5.62399C19.0977 5.22342 19.406 5.11188 19.8118 5.11188H21.1276Z",
    fill: "#1434CB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_831_67578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisacard);
export default __webpack_public_path__ + "static/media/visacard.ee6d700286bf469c7cde2ccbc162d8fa.svg";
export { ForwardRef as ReactComponent };